import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutocompleteSearchControl = _resolveComponent("AutocompleteSearchControl")!

  return (_openBlock(), _createBlock(_component_AutocompleteSearchControl, {
    search: _ctx.search,
    value: _ctx.value,
    onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('input', $event)))
  }, null, 8, ["search", "value"]))
}